import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { getPortalConfigSelector, PortalConfiguration } from "../../ducks/portalConfig";

export const useRegFormSettings = () => {
  const { t } = useTranslation();
  const config = useSelector(getPortalConfigSelector);
  const { regForm, showTermsOfService, disabledComponents } =
    (config?.settings as PortalConfiguration["settings"]) || {};
  const { title, login, password, terms, button, signIn } = regForm || {};

  return {
    title: title || t("loginTitle"),
    login: login || t("login"),
    password: password || t("password"),
    button: button || t("signUp"),
    signIn: signIn || t("signIn"),
    terms,
    showTermsOfService,
    disabledComponents,
  };
};
